
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useEffect, useState } from 'react';
import axios from 'src/utils/axios';
import { useTranslation } from 'react-i18next';
import { Grid, Box, Dialog, DialogContent, DialogContentText, DialogTitle, DialogActions, CardContent, Button, Backdrop, Container, TableCell, FormControlLabel, TablePagination, TableContainer, Divider, Paper, Table, IconButton, Card, InputAdornment, OutlinedInput, TableHead, TableBody, TableRow, TextField, Typography }
  from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { makeStyles, withStyles, useTheme } from '@material-ui/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Page from 'src/components/Page';
import { getUser } from 'src/utils/Common';


const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardscontent: {
    minHeight: 300
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
}));

function ServiceShopSearchPartner({ handleClickService }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const { t } = useTranslation('overview');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [openWarning, setopenWarning] = React.useState(false);
  const [selectedServiceShop, setSelectedServiceShop] = useState([]);
  const [serviceShopDetails, setServiceShopDetails] = useState([]);
  const classes = useStyles();
  const SessionUser = getUser();

  const serviceData = {
    serviceShopId: selectedServiceShop.ServiceShopId,
    serviceShopDsc: selectedServiceShop.SourceServiceShopCode + '-' + selectedServiceShop.Name,
    serviceShopPhone: selectedServiceShop.Phone,
    serviceShopConsumerId: selectedServiceShop.ConsumerId,
    serviceShopEmail: selectedServiceShop.Email,
    serviceShopName: selectedServiceShop.Name
  };


  const GetServiceShopShiptoPoints = () => {
    setLoading(true);
    setServiceShopDetails([]);
    axios
      .get(`/GetServiceShopShiptoPoints/` + SessionUser.ServiceShopId)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setServiceShopDetails(response.data);
        } else {
          setServiceShopDetails([]);
          const informationAlert = t('lblNoFoundServiceShop');
          setUyari(informationAlert);
          setopenWarning(true);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  }


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleClose = () => {
    setopenWarning(false);
  }

  useEffect(() => {
    GetServiceShopShiptoPoints();
  }, []);

  return (
    <Page disabled>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container maxWidth="xl" spacing={1}>
        <Divider />
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} lg={12}>
                {isMobile ? (
                  <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                    {(rowsPerPage > 0
                      ? serviceShopDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      : serviceShopDetails
                    ).map((row) => (
                      <Card key={row.ServiceShopId} style={{ marginBottom: '10px', border: '1px solid #e0e0e0' }} elevation={0}>
                        <CardContent style={{ padding: '12px', textAlign: 'left' }}>
                          <Box display="flex" alignItems="flex-start">
                            <Box mr={1}>
                              <IconButton color="primary" onClick={() => handleClickService(row)} size="small" style={{ padding: '4px' }}>
                                <AddBoxIcon fontSize="large" />
                              </IconButton>
                            </Box>
                            <Box flex={1} style={{ overflow: 'hidden' }}>
                              <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#3f51b5', lineHeight: 1.2, marginBottom: '4px', wordBreak: 'break-word' }}>
                                {row.Dsc}
                              </Typography>
                              {row.SapShiptoCode && (
                                <Typography variant="body2" color="textSecondary" style={{ marginBottom: '8px' }}>
                                  <strong>{t('lblCustomerCode')}:</strong> {row.SapShiptoCode}
                                </Typography>
                              )}
                              <Typography variant="body2" style={{ marginTop: '8px', wordBreak: 'break-word' }}>
                                <strong>{t('lblAddress')}:</strong> {row.Address}
                              </Typography>
                              <Typography variant="body2" color="textSecondary" style={{ marginTop: '2px', wordBreak: 'break-word' }}>
                                {[row.District, row.City, row.Region, row.Country].filter(Boolean).join(', ')}
                                {row.PostCode ? ` - ${row.PostCode}` : ''}
                              </Typography>
                            </Box>
                          </Box>
                        </CardContent>
                      </Card>
                    ))}
                    <TablePagination
                      rowsPerPageOptions={[5, 10]}
                      component="div"
                      count={serviceShopDetails.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                      style={{ borderTop: 'none' }}
                    />
                  </div>
                ) : (
                  <TableContainer component={Paper}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      size="small"
                      aria-label="sticky table"
                      style={{ minWidth: 800 }}
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell align="left">
                            {t('lblShipTo')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCustomerCode')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblAddress')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCountry')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblRegion')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblCity')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblDistrict')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblStreet')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblPostCode')}
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? serviceShopDetails.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : serviceShopDetails
                        ).map(row => (
                          <TableRow key={row.ServiceShopId}>
                            <TableCell align="center">
                              <FormControlLabel
                                control={
                                  <AddBoxIcon
                                    color="primary"
                                    onClick={() => handleClickService(row)}
                                  />
                                }
                              />
                            </TableCell>
                            <TableCell align="left">
                              {row.Dsc}
                            </TableCell>
                            <TableCell align="left">
                              {row.SapShiptoCode}
                            </TableCell>
                            <TableCell align="left">
                              {row.Address}
                            </TableCell>
                            <TableCell align="left">
                              {row.Country}
                            </TableCell>
                            <TableCell align="left">
                              {row.Region}
                            </TableCell>
                            <TableCell align="left">
                              {row.City}
                            </TableCell>
                            <TableCell align="left">
                              {row.District}
                            </TableCell>
                            <TableCell align="left">
                              {row.Street}
                            </TableCell>
                            <TableCell align="left">
                              {row.PostCode}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10]}
                      component="div"
                      count={serviceShopDetails.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                )}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={openWarning}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblInfo')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setopenWarning(false)} color="primary">
            {t('lblOkey')}
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
};


export default ServiceShopSearchPartner;


